/*
 * Candidate Health Certificate Messages
 *
 * This contains all the text for the Candidate Health Certificate component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidateHealthCertificate';

export default defineMessages({
  certificate: {
    id: `${scope}.certificate`,
    defaultMessage: 'Certificate {index}',
  },
  validFrom: {
    id: `${scope}.validFrom`,
    defaultMessage: 'Valid from',
  },
  validUntil: {
    id: `${scope}.validUntil`,
    defaultMessage: 'Valid until',
  },
  expired: {
    id: `${scope}.expired`,
    defaultMessage: 'Expired',
  },
  active: {
    id: `${scope}.active`,
    defaultMessage: 'Active',
  },
});
